import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Inputbox from '../../component/Inputbox';
import AuthBtn from '../../component/AuthBtn';
// import { axiosInstance as axios } from '../../axios/axios';
import * as actionCreators from '../../store/actionCreators/index';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import validate from '../../utils/inputValidation';
import { authFood, logo } from '../../assets/images/images';
import { Loader } from './Login';
// import 'react-phone-number-input/style.css';
// import PhoneInput from "react-phone-number-input";

function Signup() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();

  return (
    <div className='w-full  bg-[#f8f8f8] flex items-center justify-center'>
      {/* This will show succes box */}

      <div className='mx-auto max-w-[80vw] w-full  my-8 rounded-2xl overflow-hidden  bg-white drop-shadow-md flex gap-8 pr-8 pb-8'>
        {/* LOGO */}
        <div className='flex-1'>
          <img
            src={authFood}
            alt='logo'
            className='h-full block object-cover'
          />
        </div>
        <div className='flex-1 h-full'>
          <div className='flex items-center gap-4 mb-8 mt-4'>
            <img src={logo} alt='logo' className='block' />
            <h2 className='text-greySecondary text-2xl font-Ultra'>
              Start Restaurant
            </h2>
          </div>
          <h2 className='text-greySecondary font-Poppins font-[500] text-2xl mb-4'>
            Nice to see you again
          </h2>
          <Formik
            initialValues={{
              firstname: '',
              lastname: '',
              email: '',
              phone: '',
              password: '',
              password_confirmation: '',
              address: '',
            }}
            onSubmit={(values) => {
              dispatch(actionCreators.register(values, setLoading, navigate));
            }}
            validate={validate}
          >
            {(props) => (
              <form
                action=''
                onSubmit={props.handleSubmit}
                className=' font-Montserrat '
              >
                <div className=''>
                  {/* Name input */}
                  <div className='flex gap-2'>
                    <Inputbox
                      type='text'
                      name='firstname'
                      title='Firstname'
                      errorMsg={props.errors.firstname}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.firstname}
                      placeholder='Mary'
                    />

                    <Inputbox
                      type='text'
                      name='lastname'
                      title='Lastname'
                      errorMsg={props.errors.lastname}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.lastname}
                      placeholder='Smith'
                    />
                  </div>

                  {/* Email and phone number */}
                  <div className='flex gap-2'>
                    <Inputbox
                      type='email'
                      name='email'
                      title='Email'
                      errorMsg={props.errors.email}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.email}
                      placeholder='mary784@gmail.com'
                    />

                    <Inputbox
                      pattern='[0-9]{10}'
                      name='phone'
                      title='Phone Number'
                      errorMsg={props.errors.phone}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.phone}
                      placeholder='9845124785'
                    />
                  </div>

                  {/* Password */}
                  <div className='flex gap-2'>
                    <Inputbox
                      type='password'
                      name='password'
                      title='Password'
                      errorMsg={props.errors.password}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.password}
                      placeholder='********'
                    />

                    <Inputbox
                      type='password'
                      name='password_confirmation'
                      title='Confirm Password'
                      errorMsg={props.errors.password_confirmation}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.password_confirmation}
                      placeholder='********'
                    />
                  </div>

                  {/* Address */}
                  <div className='flex justify-between gap-[3rem] mb-4'>
                    <div className='w-full  '>
                      <Inputbox
                        type='text'
                        title='Address'
                        name='address'
                        errorMsg={props.errors.address}
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                        value={props.values.address}
                        placeholder='Naikap, Chandragiri-14'
                      />
                    </div>
                  </div>
                </div>
                <div className='w-[25rem] h-[3.625rem] mx-auto mt-[2rem] '>
                  <AuthBtn
                    className='w-full font-semibold p-3 bg-blue-500 text-center  h-full disabled:opacity-50 disabled:cursor-wait b  hover:opacity-80 hover:scale-[1.05] active:scale-[0.9] transition ease-out rounded-md shadow-xl text-white'
                    title={loading ? <Loader /> : 'Sign Up'}
                    disabled={loading}
                  />
                </div>
                <Link
                  to='/login'
                  className='text-center text-sm block text-blue-600 mt-4 hover:underline'
                >
                  Already have an account ? Log In
                </Link>
              </form>
            )}
          </Formik>
          <a
            className='flex gap-2 hover:opacity-80 transition ease-out mb-2 items-center bg-blue-600 font-semibold w-[20rem] mt-5 p-1 mx-auto rounded-md text-white'
            href='http://ef19-27-34-22-170.ngrok.io/api/login/google'
            target='blank'
          >
            <div className='bg-white p-1 rounded-sm'>
              <img
                className='w-[2rem] h-[2rem] block'
                alt='google'
                src='/images/google.webp'
              />
            </div>
            Signup with google
          </a>
        </div>
      </div>
    </div>
  );
}

export default Signup;
